const exam24 = () => import('@/pages/exam24/index.vue');
export default [
  {
    path: '/exam24',
    name: 'exam24',
    component: exam24,
  },
];
